function Ofertas () {
    return (
        <div className='max-w-[1240px] mx-auto py-16 px-4'>
            <h1 className='py-2 text-center text-indigo-300 '>Descuentos</h1>
            <hr className='py-4  border-gray-300' style={{ color: '#14b8a6' }} />
            <div className="text-center">
                <p>El sitio cuenta con descuentos especiales atribuidos al valor de la totalidad de la compra correctamente indicados en el carrito.</p>
            </div>
        </div>
    )
}


export default Ofertas



